import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { MinMaxInput } from 'components/base/Input';
import PageButton from './PageButton';

import css from './style.scss';


class Paginator extends PureComponent {
  render() {
    const { current, total, onChangePage, disabledAll } = this.props;

    // if (!total || total === 1) return null;

    const disabledLeft = current <= 1;
    const disabledRight = current >= total;

    return (
      <div className={css.pagination}>
        <div className={css.group}>
          <PageButton first disabled={disabledLeft} page={1} onClick={onChangePage} />
          <PageButton previous disabled={disabledLeft} page={current - 1} onClick={onChangePage} />
        </div>
        {console.log(total, "total")}
        <div className={css.currentPage}>
          <span className={css.pageLabel}>PAGE</span>
          <MinMaxInput className={css.input} value={current} min={1} max={total} onChange={event => onChangePage(event.value)} disabled={disabledAll} />
          <div className={css.totalGroup}>
            <span className={css.pageLabel}>OF</span>
            <span className={css.pageTotal}>{total}</span>
          </div>
        </div>

        <div className={css.group}>
          {/* disabled={disabledRight} disabled={disabledRight}  */}
          <PageButton next page={current + 1} disabled={disabledRight} onClick={onChangePage}/>
          <PageButton last page={total} disabled={disabledRight} onClick={onChangePage} />
        </div>
      </div>
    );
  }
}

Paginator.propTypes = {
  current: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  onChangePage: PropTypes.func,
  disabledAll: PropTypes.bool
};

Paginator.defaultProps = {
  disabledAll: false,
};

export default Paginator;